import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ImageService } from 'projects/Administration/src/app/services/image.service';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { DMSDefaultValuesViewModel } from '../../../business-entities/dms-defaultvalues-view-model';
import { DMSDefaultValuesService } from '../../../business-services/dms-defaultvalues.service';
@Component({
  selector: 'app-add-dms-values',
  templateUrl: './add-dms-values.component.html'
})
export class AddDmsValuesComponent implements OnInit {
  dmsDefaultValuesInfo: DMSDefaultValuesViewModel =
  {
    Rowid:0,
    DMSName:'',
    TableName:'',
    DMSColumnName:'',
    DMSValues:'',
    DMSColumnDataType:'',
  };
  imageBaseData: string | ArrayBuffer = null;
  mimeType:string = ''
  ImageBinaryData:string | ArrayBuffer = null
  imageName:string
  isValidImg:boolean = false;
  constructor(
    public service: DMSDefaultValuesService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService,
    private translate: TranslateService,
    private activeModal : NgbActiveModal,
    private imageService:ImageService
  ) { }

  ngOnInit(): void {
    // This is intentional
  }
  AddDMSDefaultValues(dmsValue:DMSDefaultValuesViewModel){
    let addedDefaultValueMessage = this.translate.instant("lblAddedDMSDefaultValueMessage");
    let alredayExistDefaultValueMessage = this.translate.instant("lblalredayExistDefaultValueMessage");
    this.spinner.show();
       this.service.AddDMSDefaultValues(dmsValue).then(res => {
         if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
           this.activeModal.close({ success: true });
           this.toaster.success(addedDefaultValueMessage);
           this.getDMSDefaultValuesList();
         }
         else if(res.responseCode === Enums.ErrorCodes.AlreadyExist){
          this.toaster.warning(alredayExistDefaultValueMessage);
         }
         this.spinner.hide();
       });
  }
  getDMSDefaultValuesList() {
    this.spinner.show();
    this.activeModal.close({ success: true });
            this.router.navigate(['/dms-defaultvalues']);
            this.spinner.hide();
          }
  OnClose(){
    this.activeModal.dismiss('Cross click')
  }
}

